import { c as _c } from "react/compiler-runtime";
import type { Subscription } from '@algoacademy/backend/modules/marketplace/enums';
import type { GroupMentoringProductDTO, IndividualMentoringProductDTO, ProjectMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { useMemo, useState } from 'react';
import { getDefaultGroupProduct } from './GroupMentoring';
import { useUpdateMentoringProductOnTabChange } from './IndividualMentoring/_hooks/updateMentoringProductOnTabChange';
import { getDefaultIndividualProduct } from './IndividualMentoring/_hooks/useInitMentoringProductWithMentoringDetailsData';
import { getDefaultProjectProduct } from './ProjectMentoring';
export function useMentoringProducts(subscription) {
  const $ = _c(13);
  let t0;
  if ($[0] !== subscription) {
    t0 = () => getDefaultIndividualProduct(subscription);
    $[0] = subscription;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [individualProduct, setIndividualProduct] = useState(t0);
  let t1;
  if ($[2] !== individualProduct || $[3] !== subscription) {
    t1 = {
      mentoringProduct: individualProduct,
      subscription,
      setMentoringProduct: setIndividualProduct
    };
    $[2] = individualProduct;
    $[3] = subscription;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useUpdateMentoringProductOnTabChange(t1);
  let t2;
  if ($[5] !== subscription) {
    t2 = getDefaultGroupProduct(subscription);
    $[5] = subscription;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const groupProduct = t2;
  let t3;
  if ($[7] !== subscription) {
    t3 = getDefaultProjectProduct(subscription);
    $[7] = subscription;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const projectProduct = t3;
  let t4;
  if ($[9] !== groupProduct || $[10] !== individualProduct || $[11] !== projectProduct) {
    t4 = {
      individualProduct,
      setIndividualProduct,
      groupProduct,
      projectProduct
    };
    $[9] = groupProduct;
    $[10] = individualProduct;
    $[11] = projectProduct;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}